import {whenReady} from "../general/Util";

class StreetNumberInput {


	constructor( parentEl ) {
		this.parentEl = parentEl;

		this.inputEl = this.parentEl.querySelector( '[data-field-type="street_and_nr"]' );
		this.streetEl = this.parentEl.querySelector( '[data-field-type="street"]' );
		this.numberEl = this.parentEl.querySelector( '[data-field-type="streetnr"]' );

		this.inputEl.value = String( this.inputEl.value ?? '' ).trim();
		[ 'input', 'change', 'focusout', 'valid_element.acl' ].forEach( ( eventName ) => {
			this.inputEl.addEventListener( eventName, () => this.onChange() );
		} );
	}

	onChange() {
		const [ streetValue, numberValue ] = this.parseStreetInput( this.inputEl.value ) ;

		if ( numberValue.length <= 0 ) {
			this.inputEl.setCustomValidity( 'Bitte geben Sie eine Hausnummer an' );
		} else if ( streetValue && streetValue.length > 35 ) {
			this.inputEl.setCustomValidity( 'Der Straßenname darf nicht länger als 35 Zeichen sein' );
			this.inputEl.reportValidity();
		}

		this.streetEl.value = streetValue ?? '';
		this.numberEl.value = numberValue ?? '';

		return this.inputEl.checkValidity();
	}

	parseStreetInput( inputValue ) {
		const [ numberValue ] = inputValue.match( /[0-9](.*)/gm ) ?? [];

		if ( 'string' === typeof numberValue && numberValue.length > 0 ) {
			return [ inputValue.replace( numberValue, '' ).trim(), numberValue ];
		}

		return [ inputValue, '' ];
	}

	static init = ( scopeEl = document ) => {
		const parentEls = scopeEl.querySelectorAll( '.acl_js--street_and_number' );
		if ( parentEls.length > 0 ) {
			parentEls.forEach( ( parentEl ) => {
				parentEl.KOE_STREET_NUMBER_INPUT ??= new StreetNumberInput( parentEl );
			} );
		}
	}
}

whenReady.then( () => {

	// Setup StreetNumberInput initialisation.
	StreetNumberInput.init();
} )

export default StreetNumberInput;
